import React from "react";
import { ThemeProvider, theme, TabsBase } from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";
import { getMonth } from "services";
import Event from "./EventCalendar";
import { useRouter } from "next/router";
import { DateTime } from "luxon";

const newTheme = {
  ...theme,
  variants: {},
};
interface Event {
  event_name: string;
  listing_id: string;
  uuid: string;
  start_date_time: string;
  end_date_time: string;
  short_code: string;
  bank_name: string;
  city_name: string;
  reserve_price: string;
  property_type: string;
  borrower_name?: string;
}
interface EventModelProps {
  eventForSelectedDate: Event[];
  handleModel: () => void;
  selectedDateMonth: {
    selectedDate: number;
    selectedMonth: number;
    selectedYear: number;
  };
}

const EventModel: React.FC<EventModelProps> = ({
  eventForSelectedDate,
  handleModel,
  selectedDateMonth,
}) => {
  const router = useRouter();
  const date = new Date();
  const currentDate = date.getDate();
  const currentMonth = date.getMonth() + 1;
  const currentYear = date.getFullYear();

  return (
    <ThemeProvider value={newTheme}>
      <div className="relative shadow-sm flex flex-col">
        <div className="flex-1">
          <div
            className={
              "absolute z-50 -top-4 -right-4 rounded-full bg-gray-50 items-center px-2 py-2 border-b text-xs text-gray-900"
            }
          >
            <div className="cursor-pointer" onClick={() => handleModel()}>
              <XIcon className="h-4 w-4" aria-hidden="true" />
            </div>
          </div>
          <div className="relative border-b bg-blue-50 text-blue-500">
            <div className="px-4 lg:px-8">
              <div className="relative py-2 text-center">
                <h2 className="text-xl font-semibold tracking-tight">
                  {selectedDateMonth?.selectedDate === currentDate &&
                  selectedDateMonth?.selectedMonth === currentMonth &&
                  selectedDateMonth.selectedYear === currentYear
                    ? "Todays Events"
                    : `Events for ${selectedDateMonth?.selectedDate} ${getMonth(
                        selectedDateMonth?.selectedMonth
                      )}`}
                </h2>
              </div>
            </div>
          </div>
          <div className="text-center overflow-hidden">
            <TabsBase
              elements={[
                {
                  title: "",
                  content: (
                    <div className="flex flex-col" key="bids-content">
                      <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 overflow-hidden align-middle px-4 md:px-6 lg:px-8">
                          <div className="overflow-hidden shadow ring-1 ring-black max-h-80 overflow-y-scroll ring-opacity-5">
                            <table className="min-w-full divide-y divide-gray-300">
                              <thead className="bg-gray-50 w-full sticky top-0">
                                <tr>
                                  <th
                                    scope="col"
                                    className="py-3.5 pl-4 pr-3 text-sm font-semibold text-gray-900 sm:pl-6 text-start"
                                  >
                                    Bank name
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-sm font-semibold text-gray-900 text-start"
                                  >
                                    City name
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-sm font-semibold text-gray-900 text-start"
                                  >
                                    Reserve price
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3.5 text-sm font-semibold text-gray-900 text-start"
                                  >
                                    Property type
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white max-h-80 overflow-auto">
                                {eventForSelectedDate.map((event, index) => (
                                  <tr
                                    className=""
                                    key={index}
                                    onClick={() => {
                                      if (
                                        window?.location?.pathname?.includes(
                                          "dashboard"
                                        )
                                      ) {
                                        router.push(
                                          `/dashboard/events/${event?.listing_id}`
                                        );
                                      } else {
                                        router.push(`/events/${event?.uuid}`);
                                      }
                                    }}
                                  >
                                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 text-start">
                                      {event?.bank_name}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-start">
                                      {event?.city_name}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-start">
                                      {event?.reserve_price}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 text-start">
                                      {/* {DateTime.fromISO(event?.end_date_time)
                                        .setZone("Asia/Kolkata")
                                        .toFormat("dd MMMM yyyy")} */}
                                      {event?.property_type}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  ),
                },
              ]}
              tabsBaseClasses={{
                wrapperClasses: "pt-0",
                layout: "flex items-center justify-center",
                height: "h-full",
                width: "w-full min-w-fit",
                backgroundColor: "bg-white",
                padding: "px-2",
                cursor: "cursor-pointer",
                borderRadius: "",
                border: "border-2 border-gray-200",
                activeTabClasses:
                  "sticky left-0 right-0 bg-gray-50 text-blue-600 border-b-0 scale-y-125 font-bold",
                inactiveTabClasses: "border-gray-200",
              }}
            />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default EventModel;
